.modal {
  user-select: none;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
}

.title {
  font-weight: 600;
}

.close {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: inherit;
}

.reasons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0;
}

.reasonButton {
  width: 100%;
  max-width: 320px;
}
